export const formatPrice = price => `$${(price / 100.0).toFixed(2)}`